import { Circulo } from './styles'

const BotaoAdicionar = () => (
  <>
    <Circulo to="/new">+</Circulo>
  </>
)

export default BotaoAdicionar
